import { deepDives } from "@/mocks/gossip";

export default function DeepDive() {
  const featured = deepDives[0];
  const rest = deepDives.slice(1);

  return (
    <section id="deep" className="scroll-mt-24 w-full bg-background-50 py-12 md:py-16">
      <div className="mx-auto w-full max-w-[1320px] px-4 md:px-6">
        <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <div>
            <p className="flex items-center gap-2 text-xs font-semibold tracking-wide text-primary-600">
              <i className="ri-quill-pen-line h-4 w-4 flex items-center justify-center text-accent-500" />
              FEATURE · 深度解读
            </p>
            <h2 className="mt-2 font-display text-2xl font-bold text-foreground-950 md:text-3xl">
              不只吃瓜，也把瓜吃明白
            </h2>
            <p className="mt-2 text-sm text-foreground-600">
              现象背后的人和事，编辑部坐下来慢慢写。
            </p>
          </div>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-5 lg:grid-cols-12">
          {/* 头条长文 */}
          <article className="group lg:col-span-7">
            <div className="flex h-full flex-col overflow-hidden rounded-xl border border-background-200 bg-background-50 transition-all duration-300 hover:border-primary-200 hover:shadow-lift">
              <div className="relative aspect-[16/9] w-full overflow-hidden lg:aspect-auto lg:h-[320px]">
                <img
                  src={featured.image}
                  alt={`${featured.title}深度长文配图`}
                  title={`${featured.title} - 99吃瓜深度解读`}
                  className="h-full w-full object-cover object-center transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute left-4 top-4 rounded bg-primary-600 px-2.5 py-1 text-xs font-medium text-background-50">
                  {featured.category}
                </span>
              </div>
              <div className="flex flex-1 flex-col p-5 md:p-6">
                <h3 className="font-display text-xl font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-700 md:text-2xl">
                  {featured.title}
                </h3>
                <p className="mt-3 flex-1 text-sm leading-relaxed text-foreground-600 md:text-base">
                  {featured.summary}
                </p>
                <div className="mt-5 flex items-center gap-3 text-xs text-foreground-400">
                  <span className="flex items-center gap-1.5">
                    <span className="flex h-6 w-6 items-center justify-center rounded-full bg-primary-100 text-primary-700">
                      <i className="ri-user-line h-3.5 w-3.5 flex items-center justify-center" />
                    </span>
                    {featured.author}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line h-3.5 w-3.5 flex items-center justify-center" />
                    {featured.readTime}
                  </span>
                  <span>{featured.date}</span>
                  <span className="ml-auto flex items-center gap-1 font-medium text-primary-600">
                    阅读全文
                    <i className="ri-arrow-right-line h-4 w-4 flex items-center justify-center transition-transform group-hover:translate-x-1" />
                  </span>
                </div>
              </div>
            </div>
          </article>

          {/* 其余长文 */}
          <div className="flex flex-col gap-5 lg:col-span-5">
            {rest.map((item) => (
              <article key={item.id} className="group flex flex-1 overflow-hidden rounded-xl border border-background-200 bg-background-50 transition-all duration-300 hover:border-primary-200 hover:shadow-soft">
                <div className="w-2/5 shrink-0 overflow-hidden">
                  <img
                    src={item.image}
                    alt={`${item.title}深度长文配图`}
                    title={`${item.title} - 99吃瓜`}
                    className="h-full w-full object-cover object-center transition-transform duration-500 group-hover:scale-105"
                  />
                </div>
                <div className="flex flex-1 flex-col justify-center p-4 md:p-5">
                  <span className="mb-2 w-fit rounded bg-accent-100 px-2 py-0.5 text-[11px] font-medium text-accent-800">
                    {item.category}
                  </span>
                  <h3 className="font-label text-base font-semibold leading-snug text-foreground-950 transition-colors group-hover:text-primary-700 md:text-lg">
                    {item.title}
                  </h3>
                  <p className="mt-2 hidden text-sm leading-relaxed text-foreground-600 sm:line-clamp-2">
                    {item.summary}
                  </p>
                  <div className="mt-3 flex items-center gap-3 text-xs text-foreground-400">
                    <span>{item.author}</span>
                    <span className="flex items-center gap-1">
                      <i className="ri-time-line h-3.5 w-3.5 flex items-center justify-center" />
                      {item.readTime}
                    </span>
                    <span>{item.date}</span>
                  </div>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}